import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { login } from '../stores/slices/loginSlice'

function ProtectRoute() {
    const isLoggedin = useSelector(state => state.loginSlice.isLoggedin)

    return isLoggedin ? <Outlet /> : <Navigate to="/" />
}

export default ProtectRoute